import { imageRegistry } from "../../data/imageRegistry";
import { ResponsiveImage } from "../ResponsiveImage/ResponsiveImage";

export function ProofSection() {
  return (
    <section
      className="primary-proof section section--major section--dark"
      data-review-region="primary-proof"
      data-auth-signature="matsushima-entity-proof"
      aria-labelledby="primary-proof-title"
    >
      <div className="section-shell">
        <div className="primary-proof__layout">
          <div className="primary-proof__copy">
            <p className="section-kicker">安心して任せられる理由</p>
            <h2 id="primary-proof-title">
              <span className="primary-proof__title-line">2014年開業</span>
              <span className="primary-proof__title-line">
                <span className="primary-proof__title-phrase">年間約900台の</span>
                <span className="primary-proof__title-phrase">買取実績</span>
              </span>
            </h2>
            <p className="primary-proof__description">
              <span>
                廃車を任せる業者だからこそ、実績と実際の対応が分かることを大切にしています。
              </span>
              <span>
                電話査定から車両確認、積載、引き取りまで、松島オートが対応します。
              </span>
            </p>
          </div>

          <figure className="proof-figure proof-figure--lift">
            <ResponsiveImage
              image={imageRegistry.primaryProofLift}
              className="responsive-image--proof"
              mobilePortrait
              signature="matsushima-real-work-proof"
            />
            <figcaption className="image-caption">
              クレーン付き積載車による実際の引き上げ作業
            </figcaption>
          </figure>

          <dl
            className="proof-numbers"
            aria-label="運営実績"
            data-testid="primary-proof-results"
          >
            <div
              className="proof-numbers__item proof-numbers__annual"
              aria-label="年間買取台数 約900台"
            >
              <dt>年間買取台数</dt>
              <dd>
                <span className="proof-numbers__approx">約</span>
                <strong>900</strong>
                <span className="proof-numbers__unit">台</span>
              </dd>
            </div>
            <div
              className="proof-numbers__item proof-numbers__since"
              aria-label="開業 2014年"
            >
              <dt>開業</dt>
              <dd>
                <strong>2014</strong>
                <span className="proof-numbers__unit">年</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
